import { SxProps, Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';
import { Color } from 'shared/utils/colors';

export const accordionSx: SxProps<Theme> = {
  m: 0,
  mb: 1,
  border: '1px solid',
  borderColor: 'rgba(0, 0, 0, 0.12)',
  borderRadius: 0,
  '&:before': { opacity: 0 },
  boxShadow: 'unset',
  '&.Mui-expanded': {
    m: 0,
    mb: 1,
  },
  '&.Mui-expanded:before': { opacity: 0 },
  '& .MuiAccordionSummary-root': {
    px: 2,
    py: 0,
    minHeight: '48px',
    '&.Mui-expanded': {
      minHeight: '48px',
      px: 2,
      py: 0,
    },
  },
  '& .MuiAccordionDetails-root': {
    p: 2,
    minWidth: 0,
    overflowX: 'clip',
  },
  '& .MuiAccordionSummary-content': {
    display: 'flex',
    justifyContent: 'space-between',
    m: '12px 0',
    '&.Mui-expanded': {
      m: '12px 0',
    },
  },
  '& .MuiAccordionSummary-expandIconWrapper': {
    ml: 2,
    flexShrink: 0,
  },
};

export const accordionIndexSx: SxProps<Theme> = {
  mr: '14px',
  flexShrink: 0,
};

export const headerRowSx: SxProps<Theme> = {
  flexGrow: 1,
};

export const accordionIndexTypographySx = (
  hasError: boolean
): SxProps<Theme> => ({
  ...accordionIndexSx,
  minWidth: 'fit-content',
  whiteSpace: 'nowrap',
  overflow: 'visible',
  textOverflow: 'unset',
  color: hasError ? Color.red : 'inherit',
});

export const accordionSummaryTypographySx = (
  hasError: boolean
): SxProps<Theme> => ({
  flexGrow: 1,
  minWidth: 0,
  overflow: 'visible',
  textOverflow: 'unset',
  whiteSpace: 'normal',
  overflowWrap: 'anywhere',
  mr: '8px',
  color: hasError ? Color.red : 'inherit',
});

export const checkIconContainerSx: SxProps<Theme> = {
  border: '1px solid #C4C4C4',
  borderRadius: '50%',
  width: 24,
  height: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  alignSelf: 'center',
  mr: '8px',
};

export const checkIconErrorContainerSx: SxProps<Theme> = {
  border: 'none',
  borderRadius: '50%',
  width: 24,
  height: 24,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

export const checkIconSx: SxProps<Theme> = {
  fill: '#C4C4C4',
  height: 16,
};

export const contentColumnSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  maxWidth: '100%',
  minWidth: 0,
};

/** Template attachments under description — Stack spacing handles vertical rhythm. */
export const templateAttachmentsWrapperSx = {
  width: '100%',
} satisfies SystemStyleObject<Theme>;
